import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { ContentContainer } from './ContentContainer';

/**
 * Authenticated application frame: persistent Sidebar + Topbar, with routed
 * content rendered into the ContentContainer via <Outlet/>.
 */
export function AppShell() {
  return (
    <div className="flex h-screen overflow-hidden bg-surface-container-low">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <ContentContainer>
            <Outlet />
          </ContentContainer>
        </main>
      </div>
    </div>
  );
}
